import React, { createContext, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

const FollowUpSentContext = createContext({
  sentStudentIds: [],
  markSent: () => {},
})

// Lives above Stream's Channel, which remounts its children for every channel,
// so students who were sent a follow-up stay skipped for the whole Messages
// session even while the cached insight still says they need one.
export function FollowUpSentProvider({ children }) {
  const [sentStudentIds, setSentStudentIds] = useState([])
  const value = useMemo(
    () => ({
      sentStudentIds,
      markSent: studentId =>
        setSentStudentIds(ids =>
          ids.includes(studentId) ? ids : [...ids, studentId],
        ),
    }),
    [sentStudentIds],
  )

  return (
    <FollowUpSentContext.Provider value={value}>
      {children}
    </FollowUpSentContext.Provider>
  )
}

FollowUpSentProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useFollowUpSent = () => useContext(FollowUpSentContext)
